import PropTypes from 'prop-types';
import React from 'react';
import TenantStatuses from '../../../../model/TenantStatuses';
import useEnumerableModel from '../../../data/hooks/useEnumerableModel';
import itemIdValue from '../../../itemIdValue';
import useT from '../../utils/Translations/useT';
import MultiselectFilter from './MultiselectFilter';

const TenantStatusSelector = props => {
  const t = useT();
  const { options } = useEnumerableModel(TenantStatuses);

  return (
    <MultiselectFilter
      itemId={itemIdValue}
      options={options}
      title={t('Status')}
      {...props}
    />
  );
};

TenantStatusSelector.propTypes = {
  value: PropTypes.arrayOf(PropTypes.oneOf(TenantStatuses.BasicValues)),
  onChange: PropTypes.func,
};

TenantStatusSelector.defaultProps = {
  value: null,
  onChange: null,
};

export default TenantStatusSelector;
